<div class="alert alert-{{type}} alert-dismissible fade show m-0" role="alert">
   {{message}}
   
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" 
    (click)='onClose()'>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
